import React, { type FC } from 'react'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import { formatKey } from '../../../utility/formatting'
import type { InfoProps } from '../utils/types'
import type { ColDef } from 'ag-grid-community'

interface InfoAgGridProps extends InfoProps {
  specialTRS?: boolean
}

const Info: FC<InfoAgGridProps> = ({
  data,
  title,
  keyFormatter = formatKey,
  valueRenderer = (value) => value,
  filter = (key, value) => !key.includes('_') && value !== null && value !== undefined,
  className = '',
  specialTRS = false
}) => {
  let rowData: Array<{ key: string, value: string | number }> = []

  if (specialTRS && data[0]) {
    const d = data[0]
    rowData = [
      { key: 'TRS Receiver', value: d.TRSReceiver },
      { key: 'Trade Date', value: d.TradeDate },
      { key: 'Effective Date', value: d.EffectiveDate },
      { key: 'Maturity Date', value: d.MaturityDate },
      { key: 'Market Value Notional Amount', value: d.MarketValueNotionalAmount },
      { key: String(d.TRSFinancingRateType), value: d.TRSFinancingRateVal },
      { key: String(d.TRSFinancingRateAmountHeader), value: String(d.TRSFinancingRateAmount) }
    ]
  } else if (data[0]) {
    rowData = Object.entries(data[0])
      .filter(([key, value]) => filter(key, value))
      .map(([key, value]) => {
        const renderedValue = valueRenderer(value, key)
        return {
          key: keyFormatter(key),
          value: typeof renderedValue === 'string' || typeof renderedValue === 'number'
            ? renderedValue
            : String(renderedValue)
        }
      })
  }

  const columnDefs = [
    {
      headerName: '',
      field: 'key',
      flex: 1,
      cellClass: 'font-semibold',
      tooltipField: 'key',
      cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    },
    {
      headerName: '',
      field: 'value',
      flex: 1,
      tooltipField: 'value',
      cellClass: 'ag-right-aligned-cell',
      cellStyle: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
    }
  ]

  return (
    <div className={`ag-info-box h-full w-full flex flex-col ${String(className)}`}>
      {title && <h4 className="font-bold mb-1">{title}</h4>}
      <div className="ag-theme-alpine flex-1 w-full h-full">
        <AgGridReact<{ key: string, value: string | number }>
          columnDefs={columnDefs as Array<ColDef<{ key: string, value: string | number }>> }
          rowData={rowData}
          domLayout="autoHeight"
          headerHeight={0}
          rowHeight={32}
          suppressCellFocus
        />
      </div>
    </div>
  )
}

export default Info
